import { useGetDealFormSelectOptions } from 'components/DealForm/hooks/useGetDealFormSelectOptions';
import useAuthContext from 'contexts/AuthContext';
import { useMemo } from 'react';
import { SpecsData } from 'views/InvestmentMemo/types';
import {
    proFormaModelParkingOptions,
} from 'views/ProFormaTable/constants';
import { useProFormaModels } from 'queries/ProForma';
import useAssetTypeDropdownOptions from 'hooks/useDisabledAssetTypesProps';

export const useSpecsLoader = (specs: SpecsData) => {
    const { selectedOrganizationId } = useAuthContext();

    const { loadingStates } = useGetDealFormSelectOptions(selectedOrganizationId);

    const { data: proFormaModels } = useProFormaModels();
    const assetTypeOptions = useAssetTypeDropdownOptions(proFormaModels || []);
    const initialAssetType = assetTypeOptions.find(assetType=> Number(assetType.value) === specs.proFormaModelId) || null;

    const parkingOptionsForModel = useMemo(
        () => (specs.proFormaModelId ? proFormaModelParkingOptions[specs.proFormaModelId] : []),
        [specs.proFormaModelId],
    );

    return {
        assetTypeOptions,
        loadingStates,
        parkingOptionsForModel,
        initialAssetType,
    };
};
